<app-modal
  [title]="title()"
  [config]="config()"
  [size]="ModalSize.MD"
  (closeModal)="cancelled.emit()">
  <div modal-body class="flex flex-col gap-3 py-2 text-sm">
    <p class="text-text-secondary">
      @if (isStepped()) {
        {{
          'features.plan.deploy.confirm.body_messages'
            | translate: { count: messageCount(), name: channelName() }
        }}
      } @else {
        {{
          'features.plan.deploy.confirm.body_single' | translate: { name: channelName() }
        }}
      }
    </p>

    @if (hasResend()) {
      <div
        data-testid="deploy-confirm-resend"
        class="bg-warning-soft border-warning flex flex-col gap-2 rounded-sm border px-3 py-2">
        <p class="text-warning font-medium">
          @if (resendUids().length > 0) {
            {{
              'features.plan.deploy.confirm.resend_warning'
                | translate: { count: resendUids().length }
            }}
          } @else {
            {{
              'features.plan.deploy.confirm.resend_warning_single'
                | translate: { date: lastSentAt() | date: 'short' }
            }}
          }
        </p>

        @if (isGedmouv()) {
          <p data-testid="deploy-confirm-gedmouv" class="text-warning">
            {{ 'features.plan.deploy.allow_redeploy.gedmouv_warning' | translate }}
          </p>
        }

        <!-- The list scrolls rather than growing: a route-sheet channel can carry a hundred
             already-sent uids, and the modal shell does not scroll its own body. -->
        @if (resendUids().length > 0) {
          <ul data-testid="deploy-confirm-uids" class="max-h-[40vh] overflow-y-auto">
            @for (uid of resendUids(); track uid) {
              <li
                data-testid="deploy-confirm-uid"
                [attr.data-uid]="uid"
                class="text-warning py-0.5 font-mono text-xs tabular-nums">
                {{ uid }}
              </li>
            }
          </ul>
        }
      </div>
    }
  </div>
</app-modal>
